import React, { useRef } from "react"

import { apiCall } from '@app/utils/apiCall';
import { useTranslation } from "react-i18next";

import { useToast } from '@app/components/3_modules/ToastContainer';
import InputEmail from "../../2_widgets/inputs/InputEmail";

import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";

export default function PasswordResetNew() {
    const refEmail = useRef();

    const { t } = useTranslation();
    
    const toast = useToast();  

    function sendResetPasswordEmail(event) {
        event.preventDefault();

        apiCall({
            method:"post", 
            path: "/api/v1/password_reset",
            data: {email: refEmail.current.getValue()},
            onSuccess:(response)=>{
                toast.addToast("", t(response.data.message));                
            },
            onError:(error)=>{
                toast.addToast("", t(error.response.data.message));
            }
        })
    }
  
    return (
        <div className="row justify-content-center me-0">
            <div className="col-xxl-6 col-lg-8 col-md-12 standard-frame">
                <h1>Renouvellement de mot de passe</h1>
                <p className="desc">
                    Entrez votre adresse mail ci-dessous et vous recevrez un lien par email pour réinitialiser votre mot de passe
                </p>
                <form onSubmit={sendResetPasswordEmail}>
                    <InputEmail
                        ref={refEmail}
                        label="E-mail" 
                        isRequired={true}
                    />
                    <div className="form-group">
                        <ButtonPrimary label="Réinitialiser" />
                    </div>
                </form>
            </div>
        </div>
    )
}
